import { render } from "./BaseImage.vue?vue&type=template&id=376cc11e&scoped=true"
import script from "./BaseImage.vue?vue&type=script&lang=js"
export * from "./BaseImage.vue?vue&type=script&lang=js"

import "./BaseImage.vue?vue&type=style&index=0&id=376cc11e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-376cc11e"]])

export default __exports__